import React, { useEffect, useState, useCallback } from 'react'
import styled from 'styled-components'
import { Text } from 'rebass'
// components
import Loading from '../../components/Loader/Loading'
import { BodyHead, BodyTitle } from '../../components/bakery/styleds'
import NoArtworks from '../../components/Gamification/NoArtworks'
import {Artworks} from '../../components/Gamification/Artworks'
import { ButtonLight } from '../../components/Button'
import StakeRow from '../../components/Gamification/StakeRow'

// hooks
import { useActiveWeb3React } from '../../hooks'
import { useWalletModalToggle } from '../../state/application/hooks'

import { NFTTYPE } from '../../constants/bakery/nft'
import useYam from '../../hooks/bakery/useYam'
import { GameProps } from '../../constants/Gamification'
import useInterval from '../../hooks/useInterval'
import {
    getErc721Balance,
    getNftHelperContract,
    getCarBlindBoxAddress,
    getBalanceCarNFTs,
    getAllStakingCarNFTs,
    getCarNFTMasterContract,
    getCarNFTContract
} from '../../sushi/utils'


const UpToButtonLight = styled(ButtonLight)`
  margin-top: 160px;
  padding: 0px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-top: 80px;
  `}
`
const ArtworksList = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 1204px;
  margin: auto;
  box-sizing: border-box;
  justify-content: flex-start;

  ${({ theme }) => theme.mediaWidth.upToBigerLarge`
    width: 904px;
  `}

  ${({ theme }) => theme.mediaWidth.upToLarge`
    width: 628px;
  `}

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 605px;
  `}

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
    padding: 0px 20px;
    justify-content: center;
  `}
`

export default function MyArtworks() {
    // 钱包信息
    const { account } = useActiveWeb3React()
    const toggleWalletModal = useWalletModalToggle()

    // 初始化加载动画
    const [loadingFlag, setLoadingFlag] = useState(false)

    // 获取sushi
    const sushi = useYam()

    // 获取盲盒
    const fetchNftId = useCallback(async (isLoading?: boolean) => {
        // 加载动画
        if (isLoading) {
            setLoadingFlag(true)
        }
        let balanceArr: any = []
        const nftHelper = getNftHelperContract(sushi)
        const carBlindBoxAddress = getCarBlindBoxAddress(sushi)
        balanceArr = await getErc721Balance(nftHelper, carBlindBoxAddress, account)
        const image = "/images/nft/carbox.png"
        const boxs = balanceArr.map((d: string) => {
            return {
                tokenId: d,
                image: image,
                minImage: image,
                name: 'blindbox',
                lockedCAR: '-',
                stakingPower: false,
                showBorder: false,
                titleName: 'Rare Car Box',
                nftName: 'Car NFT',
                unlockFee: '1%',
                isCanTransfer: true
            }
        })
        if (!boxs) return
        return boxs
    }, [account, sushi])

    // 获取余额中的扑克牌
    const fetchBalanceCarNfts = useCallback(async (isLoading?: boolean) => {
        // 加载动画
        if (isLoading) {
            setLoadingFlag(isLoading)
        }
        let cardArr: any = []
        cardArr = await getBalanceCarNFTs(sushi, account)
        const cards = cardArr.map((d: GameProps) => {
            return {
                tokenId: d.tokenId,
                image: d.image,
                minImage: d.minImage,
                name: d.name,
                lockedCAR: d.lockedCAR,
                stakingPower: d.stakingPower,
                showBorder: d.size === '1' ? true : false,
                titleName: 'CAR Model',
                nftName: 'Car NFT',
                unlockFee: '1%',
                isCanTransfer: true
            }
        })
        if (!cards) return
        return cards
    }, [account, sushi])

    // 获取抵押中的扑克牌
    const fetchAllStakingCarNft = useCallback(async (isLoading?: boolean) => {
        // 加载动画
        if (isLoading) {
            setLoadingFlag(isLoading)
        }
        let cardArr: any = []
        let carMasterContract = getCarNFTMasterContract(sushi)
        let carContract = getCarNFTContract(sushi)
        cardArr = await getAllStakingCarNFTs(carMasterContract, carContract, account)
        const stakingCars = cardArr.map((d: GameProps) => {
            return {
                tokenId: d.tokenId,
                image: d.image,
                minImage: d.minImage,
                name: d.name,
                lockedCAR: d.lockedCAR,
                stakingPower: d.stakingPower,
                showBorder: d.size === '1' ? true : false,
                titleName: 'CAR Model',
                nftName: 'Car NFT',
                unlockFee: '1%',
                isCanTransfer: true
            }
        })
        if (!stakingCars) return
        return stakingCars
    }, [account, sushi])

    // 拼接所有nft
    const [artworks, setArtworks] = useState<any[]>([])
    const fetchArtworks = useCallback(async (isLoading?: boolean) => {
        // 加载动画
        if (isLoading) {
            setLoadingFlag(true)
        }
        // 获取盲盒
        const blindBoxs = await fetchNftId(isLoading)
        // 获取余额中的扑克牌
        const CarNfts = await fetchBalanceCarNfts(isLoading)
        // 获取抵押中的扑克牌
        const allstakingCarNfts = await fetchAllStakingCarNft(isLoading)

        const allNfts = [...blindBoxs, ...CarNfts, ...allstakingCarNfts]
        // 拼接nft
        if (!blindBoxs.length && !CarNfts.length && !allNfts.length) {
            setArtworks([])
            setLoadingFlag(false)
        } else {
            let obj: any = {}
            let all = allNfts.reduce((cur, next) => {
                !obj[next.tokenId] && (obj[next.tokenId] = true && cur.push(next))
                return cur
            }, [])
            setArtworks(all)
            setLoadingFlag(false)
        }
    }, [fetchNftId, fetchBalanceCarNfts, fetchAllStakingCarNft])

    // 初始化渲染
    useEffect(() => {
        if (account) {
            fetchArtworks(false)
        }
    }, [account, fetchArtworks])

    useInterval(fetchArtworks, account ? 10000 : null)

    return (
        <>
            <Loading open={loadingFlag} />
            {
                !account ? (
                    <UpToButtonLight width={'180px'} height={40} onClick={toggleWalletModal}>
                        Connect Wallet
                    </UpToButtonLight>
                ) : <>
                    <BodyHead>
                        <BodyTitle fontSize={32} fontWeight={700}>My Gift Box NFTs</BodyTitle>
                        <Text fontSize={16}>
                            Wish you could get your best Gift Box NFTs {' '}
                            <span role="img" aria-label="smile">
                                😋
                </span>
                        </Text>
                    </BodyHead>
                    <StakeRow type={NFTTYPE.CAR} />
                    {
                        loadingFlag
                            ? null
                            : !account || artworks.length === 0 ? (
                                <NoArtworks ownBtn={true} nftName={'Gift Box NFTs'} />
                            ) : (
                                <>
                                    <ArtworksList>
                                        {
                                            artworks.map((d, index) => {
                                                return (
                                                    <Artworks
                                                        key={index}
                                                        artwork={d}
                                                        artworklength={artworks.length}
                                                        type={NFTTYPE.CAR}
                                                        isMyArtwork={true}
                                                        showBorder={d.showBorder}
                                                        isBlindbox={d.name === 'blindbox' ? true : false}
                                                        isCanTransfer={d.isCanTransfer}
                                                        isCanStake={true}
                                                    />
                                                )
                                            })
                                        }
                                    </ArtworksList>
                                </>
                            )
                    }
                </>
            }
        </>
    )
}